import {
  getVendorType,
  getVendorOptions,
} from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useVendorType() {
  //Fetching Vendor Details
  return useQuery("GetVendorType", getVendorType, {
    refetchOnWindowFocus: false,
  });
}
export const useGetVendorOptions = () => {
  const { data } = useQuery("vendorOptions", getVendorOptions, {
    refetchOnWindowFocus: false,
  });
  return data;
};
